export default __webpack_public_path__ + "static/media/base-report18.4b591999.png";